import { render, staticRenderFns } from "./PhoneCountryCode.vue?vue&type=template&id=20632222"
import script from "./PhoneCountryCode.vue?vue&type=script&lang=js"
export * from "./PhoneCountryCode.vue?vue&type=script&lang=js"
import style0 from "./PhoneCountryCode.vue?vue&type=style&index=0&id=20632222&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports